import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 bg-[#050505]">
    <div className="mx-auto max-w-[1600px] px-5 sm:px-8 py-20">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <h2 className="font-display text-4xl sm:text-6xl uppercase tracking-tighter leading-[0.95]">
            Start your<br /><span className="text-primary">project.</span>
          </h2>
          <p className="mt-5 max-w-md text-white/60">Drop us a line! We are here to answer your questions promptly.</p>
          <Link
            to="/contact"
            data-testid="footer-quote-btn"
            className="inline-flex items-center gap-2 mt-8 hover-fill px-6 py-3 font-mono text-xs uppercase tracking-widest"
          >
            Request a Quote <ArrowUpRight size={14} />
          </Link>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-widest text-white/40 mb-5">Navigate</p>
          <ul className="space-y-3">
            {[
              { l: "Home", to: "/" },
              { l: "Services", to: "/services" },
              { l: "Industries", to: "/industries" },
              { l: "Sustainability & CSR", to: "/sustainability" },
              { l: "About", to: "/about" },
              { l: "Contact", to: "/contact" },
              { l: "Career", to: "/career" },
              { l: "Resources", to: "/resources" },
            ].map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="text-white/70 hover:text-primary transition-colors duration-300">{item.l}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[11px] uppercase tracking-widest text-white/40 mb-5">Contact</p>
          <ul className="space-y-3 text-white/70">
            <li>info@freight-iq.com</li>
            <li>+1 647 657 3905</li>
            <li>211 - 320 Matheson Blvd West,<br />Mississauga, ON L5R 0H2, Canada</li>
          </ul>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 font-mono text-[11px] uppercase tracking-widest text-white/40">
        <span>© {new Date().getFullYear()} Freight IQ International Inc. — Global Transport & Logistics</span>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-primary transition-colors">Admin</Link>
      </div>
    </div>
  </footer>
);
